import { Organisation } from '@/common/types/organisation';

export function isUserAdmin(
  organisation: Organisation | null | undefined,
  userId: string | null | undefined,
): boolean {
  if (!organisation || !userId) return false;

  const member = organisation.members.find((m) => m.uid === userId);
  if (!member) return false;

  return member.role === 'admin';
}
